import { TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'

const Pagstar = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">Client ID</label>
                <TextField
                    error={(error.pagstar_client_id) && true}
                    value={account.pagstar_client_id || ''}
                    onChange={e => {
                        dispatch(change({pagstar_client_id: e.target.value}))
                        if (error.pagstar_client_id && delete error.pagstar_client_id);
                    }}
                />

                {(error.pagstar_client_id) &&
                    <strong className="text-danger">{error.pagstar_client_id[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client Secret</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.pagstar_client_secret) && true}
                    value={account.pagstar_client_secret || ''}
                    onChange={e => {
                        dispatch(change({pagstar_client_secret: e.target.value}))
                        if (error.pagstar_client_secret && delete error.pagstar_client_secret);
                    }}
                />

                {(error.pagstar_client_secret) &&
                    <strong className="text-danger">{error.pagstar_client_secret[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Chave Pix</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.pagstar_pix_key) && true}
                    value={account.pagstar_pix_key || ''}
                    onChange={e => {
                        dispatch(change({pagstar_pix_key: e.target.value}))
                        if (error.pagstar_pix_key && delete error.pagstar_pix_key);
                    }}
                />

                {(error.pagstar_pix_key) &&
                    <strong className="text-danger">{error.pagstar_pix_key[0]}</strong>
                }
            </div>
        </>
    )
}


export default Pagstar